var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    version: "0.0.2",
    username: "zack+4@haiku.ai",
    organization: "zack4",
    project: "animatorLogo",
    branch: "master",
    folder: "/Users/zack/.haiku/projects/zack4/animatorLogo",
    uuid: "981a3477-4e4a-4ade-bde4-e0151af36a60",
    root: "https://cdn.haiku.ai/f20c7403-4da1-4110-b85f-fcff00ac0264/4dab159ad07325a14f9e56ec79871f23b9c0a44d/",
    core: "4.5.0",
    title: "Main",
    type: "haiku",
    relpath: "code/main/code.js"
  },
  options: {},
  states: {
    bgColor: { type: "string", value: "transparent", edited: true },
    fgColor: { type: "string", value: "#070E18", edited: true }
  },
  eventHandlers: {},
  timelines: {
    Default: {
      "haiku:Path-2-dfa4f1f6cca73d4f": {
        "style.margin": "0",
        "sizeAbsolute.y": 114,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 128,
        "sizeMode.x": 1,
        "style.position": "absolute",
        "sizeMode.y": 1,
        "translation.x": {
          "0": { value: 397.753, edited: true },
          "1000": { value: 39.027, edited: true, curve: "easeInOutQuad" },
          "1067": { value: 58.312, edited: true, curve: "easeInOutQuad" },
          "1283": { value: 65.604, edited: true },
          "1567": { value: 65.604, edited: true, curve: "easeInOutQuad" },
          "1917": { value: 65.496, edited: true, curve: "easeInOutQuad" },
          "2033": { value: 65.481, edited: true, curve: "easeInOutQuad" },
          "2250": { value: 65.45, edited: true }
        },
        "translation.y": {
          "0": { value: 170.1780205078125, edited: true },
          "1000": { value: 65.098, edited: true, curve: "easeInOutQuad" },
          "1100": { value: 61.42, edited: true, curve: "easeInOutQuad" },
          "1283": { value: 42.233, edited: true },
          "1567": { value: 42.233, edited: true, curve: "easeInOutQuad" },
          "1917": { value: 52.62, edited: true, curve: "easeInOutQuad" },
          "2033": { value: 54.111, edited: true, curve: "easeInOutQuad" },
          "2250": { value: 57.105, edited: true }
        },
        "style.zIndex": { "0": { value: 3, edited: true } },
        "scale.x": {
          "0": { value: 0.524, edited: true },
          "1000": { value: 0.272, edited: true, curve: "easeOutBack" },
          "1333": { value: 0.716, edited: true },
          "1567": { value: 0.716, edited: true, curve: "easeInOutQuad" },
          "2250": { value: 0.995, edited: true }
        },
        "scale.y": {
          "0": { value: 0.524, edited: true },
          "1000": { value: 0.109, edited: true, curve: "easeOutBack" },
          "1333": { value: 0.715, edited: true },
          "1567": { value: 0.715, edited: true, curve: "easeInOutQuad" },
          "2250": { value: 0.993, edited: true }
        },
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1000": {
            value: -2.5249999999999995,
            edited: true,
            curve: "easeOutBack"
          },
          "1283": { value: 0, edited: true, curve: "easeInOutQuad" },
          "1733": { value: 0, edited: true, curve: "easeInOutQuad" },
          "1917": { value: 0.129, edited: true, curve: "easeInOutQuad" },
          "2033": { value: -0.22, edited: true, curve: "easeInOutQuad" },
          "2250": { value: 0, edited: true }
        },
        opacity: 1
      },
      "haiku:Linear-Gradient-1-2db749-95a3f9579dad9a19": {
        x1: "83.4146793%",
        y1: "9.82956494%",
        x2: "16.8409543%",
        y2: "82.2812111%"
      },
      "haiku:Stop-cdeb99092b9623d8": { stopColor: "#F66045", offset: "0%" },
      "haiku:Stop-c0421130149019d6": { stopColor: "#EF34F4", offset: "100%" },
      "haiku:Page-1-9fa83a73d34094a2": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Path-2-c91fc96c9ea04b29": {
        d: {
          "0": {
            value:
              "M125.935288,107.829102 C124.656738,111.042969 120.056152,113.986774 118.626465,113.993387 C117.67334,113.997796 81.0653681,114 8.80254953,114 C4.98398786,113.164291 2.3914388,111.107325 1.02490234,107.829102 C-0.341634115,104.550879 -0.341634115,100.702571 1.02490234,96.2841797 L52.8833008,5.64257813 C54.3829922,2.03057516 57.6130583,0.187144733 62.5734991,0.11228684 C67.5339398,0.0374289466 71.1489258,2.33398437 73.418457,7.00195312 L125.935288,99.3154297 C127.645617,102.321825 127.213839,104.615234 125.935288,107.829102 Z",
            edited: true
          },
          "1617": {
            value:
              "M125.935288,107.829102 C124.656738,111.042969 120.056152,113.986774 118.626465,113.993387 C117.67334,113.997796 81.0653681,114 8.80254953,114 C4.98398786,113.164291 2.3914388,111.107325 1.02490234,107.829102 C-0.341634115,104.550879 -0.341634115,100.702571 1.02490234,96.2841797 L52.8833008,5.64257813 C54.3829922,2.03057516 57.6130583,0.187144733 62.5734991,0.11228684 C67.5339398,0.0374289466 71.1489258,2.33398437 73.418457,7.00195312 L125.935288,99.3154297 C127.645617,102.321825 127.213839,104.615234 125.935288,107.829102 Z",
            edited: true,
            curve: [0.72, -0.13, 0.265, 1.5]
          },
          "2083": {
            value:
              "M100.722336,52.6813857 C100.722336,53.5441276 100.650038,54.2226777 100.323648,54.9732996 C85.3558139,89.3959115 51.4807595,113.536206 11.9699936,113.993393 C5.84648885,113.786717 0.945782475,108.757512 0.945782475,102.583686 C0.945782475,100.590429 1.46765962,98.6319083 2.45950137,96.9029429 L54.6932313,5.84979439 C57.8306188,0.380741873 64.807517,-1.50944607 70.2765695,1.62794145 C72.0333586,2.6357446 73.4904182,4.09276475 74.4982688,5.84952665 L100.073593,50.4293021 C100.44603,51.0578887 100.662277,51.7969067 100.722336,52.6463561 C100.722343,52.6580676 100.722336,52.6697263 100.722336,52.6813857 Z",
            edited: true
          }
        },
        fill: "url(#linearGradient-1-2db749)"
      },
      "haiku:Path-2-af1a6cd5d22c7ebf": {
        "sizeMode.y": 1,
        "sizeMode.x": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 128,
        "style.margin": "0",
        "sizeAbsolute.y": 114,
        "style.position": "absolute",
        "translation.x": {
          "0": { value: 274.5, edited: true },
          "1550": {
            value: 65.19799804687501,
            edited: true,
            curve: "easeInOutQuad"
          },
          "1767": { value: 92.751, edited: true, curve: "easeInOutQuad" },
          "1800": { value: 85.096, edited: true, curve: "easeInOutQuad" },
          "1833": { value: 108.809, edited: true, curve: "easeInOutQuad" },
          "1867": { value: 119.651, edited: true, curve: "easeInOutQuad" },
          "1983": { value: 142.095, edited: true, curve: "easeInOutQuad" },
          "2250": { value: 147.19, edited: true }
        },
        "translation.y": {
          "0": { value: 200, edited: true },
          "1550": {
            value: 45.641996582031254,
            edited: true,
            curve: "easeInOutQuad"
          },
          "1767": { value: 67.454, edited: true, curve: "easeInOutQuad" },
          "1800": { value: 70.747, edited: true, curve: "easeInOutQuad" },
          "1833": { value: 79.417, edited: true, curve: "easeInOutQuad" },
          "1867": { value: 88.179, edited: true, curve: "easeInOutQuad" },
          "1983": { value: 98.777, edited: true, curve: "easeInOutQuad" },
          "2250": { value: 123.338, edited: true }
        },
        "style.zIndex": { "0": { value: 2, edited: true } },
        "scale.x": {
          "0": { value: 1, edited: true },
          "1550": { value: 0.656, edited: true, curve: "easeInOutQuad" },
          "1767": { value: 0.248, edited: true, curve: "easeInOutQuad" },
          "1800": { value: 0.415, edited: true, curve: "easeInOutQuad" },
          "1867": { value: 0.353, edited: true, curve: "easeInOutQuad" },
          "1983": { value: 0.622, edited: true, curve: "easeInOutQuad" },
          "2250": { value: 0.984, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "1550": { value: 0.656, edited: true, curve: "easeInOutQuad" },
          "1767": { value: 0.375, edited: true, curve: "easeInOutQuad" },
          "1800": { value: 0.395, edited: true, curve: "easeInOutQuad" },
          "1867": { value: 0.338, edited: true, curve: "easeInOutQuad" },
          "1983": { value: 0.604, edited: true, curve: "easeInOutQuad" },
          "2250": { value: 0.984, edited: true }
        },
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1700": { value: 0, edited: true },
          "1717": { value: 0, edited: true, curve: "easeInOutQuad" },
          "1767": { value: -0.257, edited: true, curve: "easeInOutQuad" },
          "1867": { value: -0.155, edited: true, curve: "easeInOutQuad" },
          "1983": { value: -0.254, edited: true, curve: "easeInOutQuad" },
          "2250": { value: 0, edited: true }
        },
        opacity: 1
      },
      "haiku:Linear-Gradient-1-A2f1bf-dd579bf2bb55ca45": {
        x1: "83.4146793%",
        y1: "9.82956494%",
        x2: "16.8409543%",
        y2: "82.2812111%"
      },
      "haiku:Stop-490ca8708059018e": { stopColor: "#F66045", offset: "0%" },
      "haiku:Stop-bd5d9c00639d63bb": { stopColor: "#EF34F4", offset: "100%" },
      "haiku:Page-1-d0721883a5cc8b0d": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Path-2-7a635180adee9604": {
        d: {
          "0": {
            value:
              "M125.935288,107.829102 C124.656738,111.042969 120.056152,113.986774 118.626465,113.993387 C117.67334,113.997796 81.0653681,114 8.80254953,114 C4.98398786,113.164291 2.3914388,111.107325 1.02490234,107.829102 C-0.341634115,104.550879 -0.341634115,100.702571 1.02490234,96.2841797 L52.8833008,5.64257813 C54.3829922,2.03057516 57.6130583,0.187144733 62.5734991,0.11228684 C67.5339398,0.0374289466 71.1489258,2.33398437 73.418457,7.00195312 L125.935288,99.3154297 C127.645617,102.321825 127.213839,104.615234 125.935288,107.829102 Z",
            edited: true
          },
          "1700": {
            value:
              "M125.935288,107.829102 C124.656738,111.042969 120.056152,113.986774 118.626465,113.993387 C117.67334,113.997796 81.0653681,114 8.80254953,114 C4.98398786,113.164291 2.3914388,111.107325 1.02490234,107.829102 C-0.341634115,104.550879 -0.341634115,100.702571 1.02490234,96.2841797 L52.8833008,5.64257813 C54.3829922,2.03057516 57.6130583,0.187144733 62.5734991,0.11228684 C67.5339398,0.0374289466 71.1489258,2.33398437 73.418457,7.00195312 L125.935288,99.3154297 C127.645617,102.321825 127.213839,104.615234 125.935288,107.829102 Z",
            edited: true,
            curve: "easeInOutQuad"
          },
          "2100": {
            value:
              "M1.54068502,31.9079382 C5.26420899,20.3407875 10.7331511,11.5199377 17.3523328,2.44067783 C18.2596942,1.19608748 20.1434314,0.132261158 22.049509,0.304249421 C22.0520685,0.304206442 22.0547255,0.304066626 22.0574798,0.303830273 C22.0591685,0.303998584 22.0608436,0.304138301 22.0625049,0.304249421 C23.6506384,0.410476969 25.0221866,1.23694783 26.1771494,2.78366199 L41.7352708,29.9026752 C43.0206494,32.1431897 43.4622272,34.6367976 43.1596057,37.0158193 C42.6108383,42.6213479 37.9278784,47 32.2320957,47 C32.1658855,47 32.0998121,46.9994083 32.0338804,46.9982299 C31.9669075,46.9994093 31.8998879,47 31.8328289,47 L11.8294494,47 C11.8144014,46.9999693 11.7993184,47 11.7842282,47 C5.71944457,47 0.802966027,42.035629 0.802966027,35.911767 C0.802966027,35.1215293 0.884834901,34.3505994 1.04047558,33.6071532 C1.04966398,33.5148034 1.06835327,33.4210912 1.09725542,33.3259069 C1.10675639,33.2946171 1.11626982,33.2633475 1.12579569,33.232098 C1.2371392,32.7790728 1.37606988,32.337047 1.54068328,31.9079436 L1.54068502,31.9079382 Z",
            edited: true
          }
        },
        fill: "url(#linearGradient-1-a2f1bf)"
      },
      "haiku:Diamond-Copy-32-012380ac5456526a": {
        "style.margin": "0",
        "sizeMode.y": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 31,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 36,
        "style.position": "absolute",
        "translation.x": {
          "0": { value: 500, edited: true, curve: "easeInBack" },
          "817": { value: -0.147, edited: true, curve: "easeInOutQuad" },
          "900": { value: 8.774, edited: true, curve: "easeInOutQuad" },
          "983": { value: 42, edited: true, curve: [0.455, 0.03, 0.595, 0.77] },
          "1317": { value: 60, edited: true, curve: "easeInOutQuad" },
          "1450": {
            value: 60.698,
            edited: true,
            curve: [0.515, 0, 0.43, 1.31]
          },
          "2250": { value: 115.928, edited: true }
        },
        "translation.y": {
          "0": {
            value: 60.95400000000001,
            edited: true,
            curve: "easeInOutQuad"
          },
          "817": { value: 60.805, edited: true, curve: "easeInCirc" },
          "900": {
            value: 60.95399999999999,
            edited: true,
            curve: "easeInOutQuad"
          },
          "1317": { value: 119.009, edited: true, curve: "easeInOutQuad" },
          "1450": {
            value: 118.992,
            edited: true,
            curve: [0.225, 0.335, 0.565, 1.2]
          },
          "2250": { value: 56.279, edited: true }
        },
        "style.zIndex": { "0": { value: 13, edited: true } },
        "scale.x": {
          "983": { value: 2, edited: true, curve: "easeInOutQuad" },
          "0": { value: 2.437, edited: true, curve: "easeInOutQuad" },
          "433": { value: 2.437, edited: true, curve: "easeInOutQuad" },
          "817": { value: 5, edited: true, curve: "easeInOutQuad" },
          "900": { value: 0.678, edited: true, curve: "easeInOutQuad" },
          "250": { value: 2.1, edited: true, curve: "easeInOutQuad" },
          "1283": { value: 1, edited: true },
          "1433": { value: 1, edited: true, curve: "easeInOutQuad" },
          "1750": { value: 0.7, edited: true, curve: "easeInOutQuad" },
          "1950": { value: 1, edited: true, curve: "easeOutBack" },
          "2150": { value: 1, edited: true }
        },
        "scale.y": {
          "983": { value: 2, edited: true, curve: "easeInOutQuad" },
          "0": { value: 2.437, edited: true, curve: "easeInOutQuad" },
          "433": { value: 2.437, edited: true, curve: "easeInOutQuad" },
          "817": { value: 1.5, edited: true, curve: "easeInOutQuad" },
          "900": { value: 3.302, edited: true, curve: "easeInOutQuad" },
          "250": { value: 2.6, edited: true, curve: "easeInOutQuad" },
          "1283": { value: 1, edited: true },
          "1433": { value: 1, edited: true, curve: "easeInOutQuad" },
          "1750": { value: 1.3, edited: true },
          "1917": { value: 1.3, edited: true, curve: "easeOutBack" },
          "2250": { value: 1, edited: true }
        },
        "rotation.z": {
          "0": { value: -3.1415927, edited: true },
          "983": {
            value: -3.1415927,
            edited: true,
            curve: [0.455, 0.03, 0.465, 0.985]
          },
          "1367": { value: 0, edited: true },
          "1383": { value: 0, edited: true, curve: "easeInOutQuad" },
          "1617": { value: 0.576, edited: true, curve: "easeInOutQuad" },
          "2250": { value: 0, edited: true }
        },
        "origin.x": {
          "0": { value: 0, edited: true, curve: "easeInOutQuad" },
          "433": { value: 0, edited: true, curve: "easeInOutQuad" },
          "817": {
            value: 0.999,
            edited: true,
            curve: [0.485, 0.01, 0.515, 0.955]
          },
          "983": { value: 0.5, edited: true, curve: "easeInOutQuad" },
          "1050": { value: 0.5, edited: true, curve: "easeInOutQuad" },
          "1317": { value: 0.488, edited: true }
        },
        "origin.y": {
          "0": { value: 0.5, edited: true },
          "433": { value: 0.5, edited: true, curve: "easeInOutQuad" },
          "817": { value: 0.499, edited: true, curve: "easeInOutQuad" },
          "983": { value: 0.5, edited: true, curve: "easeInOutQuad" },
          "1050": { value: 0.5, edited: true, curve: "easeInOutQuad" },
          "1317": { value: 0.922, edited: true }
        },
        opacity: 1
      },
      "haiku:Linear-Gradient-1-13dfc6-38d7a30a8ef0258a": {
        x1: "33.7565155%",
        y1: "12.8556931%",
        x2: "66.8709721%",
        y2: "87.4887573%"
      },
      "haiku:Main-03757d2ca1026e0a": {
        "sizeAbsolute.y": 121.908,
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.overflowX": "hidden",
        "style.overflowY": "hidden",
        "sizeAbsolute.x": 550,
        "style.position": "relative",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1,
        "style.backgroundColor": {
          "0": {
            value: Haiku.inject(function(bgColor) {
              return bgColor;
            }, "bgColor"),
            edited: true
          }
        },
        "style.background": { "0": { value: 1, edited: true } }
      },
      "haiku:Stop-bb8bcc406964d868": { stopColor: "#F246AB", offset: "100%" },
      "haiku:Page-1-a697b632a22d76c8": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Diamond-Copy-32-89844bd46ba48c4f": {
        d:
          "M0.707191911,17.9706033 C0.687928678,16.3839694 1.51445752,14.4399786 3.25708443,12.3398411 L11.8253312,2.77847156 C14.0573044,0.0885953484 17.6548089,0.0983600319 19.8786797,2.77847156 L28.4469265,12.3398411 C30.1903558,14.4409456 31.0178793,16.3845567 30.9997072,17.9706033 C31.0178793,19.5566499 30.1903558,21.500261 28.4469265,23.6013655 L19.8786797,33.162735 C17.6548089,35.8428466 14.0573044,35.8526112 11.8253312,33.162735 L3.25708443,23.6013655 C1.51445752,21.501228 0.687928678,19.5572372 0.707191911,17.9706033 Z",
        fill: { "0": { value: "url(#linearGradient-1-13dfc6)", edited: true } }
      },
      "haiku:Full-Group-086e4bed4e4c459c": {
        "style.margin": "0",
        "sizeAbsolute.y": 121,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 551,
        "sizeMode.x": 1,
        "style.position": "absolute",
        "sizeMode.y": 1,
        "translation.x": 275,
        "translation.y": 60.5,
        "style.zIndex": { "0": { value: 1, edited: true } },
        opacity: {
          "0": { value: 0, edited: true, curve: "easeInOutQuad" },
          "2250": { value: 0, edited: true }
        }
      },
      "haiku:Stop-988850c829312872": { stopColor: "#F5566E", offset: "0%" },
      "haiku:By-Haiku-Copy-35944b0a063252e8": {
        "sizeAbsolute.y": 28,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 123,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeMode.y": 1,
        "translation.x": {
          "0": { value: 488, edited: true },
          "1667": { value: 489, edited: true }
        },
        "translation.y": {
          "0": { value: 151.333251953125, edited: true },
          "1667": { value: 91.927, edited: true, curve: "easeInOutQuad" },
          "2017": { value: 106.927, edited: true }
        },
        "style.zIndex": { "0": { value: 4, edited: true } },
        opacity: {
          "0": { value: 1, edited: true },
          "1667": { value: 0, edited: true, curve: "easeInOutQuad" },
          "2367": { value: 1, edited: true }
        }
      },
      "haiku:Linear-Gradient-1-176eee-23a6b10f96a0babb": {
        x1: "100%",
        y1: "15.7237935%",
        x2: "18.9087946%",
        y2: "81.9605306%"
      },
      "haiku:Stop-934c92bd402c280e": { stopColor: "#F66045", offset: "0%" },
      "haiku:Stop-bed321f8d0b812fd": { stopColor: "#EF34F4", offset: "100%" },
      "haiku:Page-1-82f29448178d578a": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Full-Group-37c9aede0f61e809": {
        fillRule: "nonzero",
        "translation.x": 1
      },
      "haiku:Animator-Copy-70d065c90ce41146": {
        d:
          "M188.914419,86.3374536 L185.445265,76.0679852 L163.804355,76.0679852 L160.335202,86.3374536 L145.55,86.3374536 L166.530119,28.1990111 L182.8847,28.1990111 L203.864819,86.3374536 L188.914419,86.3374536 Z M181.810914,65.1359703 L174.62481,43.8516687 L167.521306,65.1359703 L181.810914,65.1359703 Z M242.025507,86.3374536 L242.025507,61.2435105 C242.025507,54.9493201 238.556354,51.4709518 233.187426,51.4709518 C227.818498,51.4709518 224.349344,54.9493201 224.349344,61.2435105 L224.349344,86.3374536 L210.224933,86.3374536 L210.224933,40.1248455 L224.349344,40.1248455 L224.349344,46.2533993 C227.157706,42.3609394 232.11364,39.6279357 238.308557,39.6279357 C248.963814,39.6279357 256.067319,46.9159456 256.067319,59.3386897 L256.067319,86.3374536 L242.025507,86.3374536 Z M265.896587,86.3374536 L265.896587,40.1248455 L280.020998,40.1248455 L280.020998,86.3374536 L265.896587,86.3374536 Z M273.000092,35.3213844 C267.96156,35.3213844 264.575005,31.9258344 264.575005,27.7021014 C264.575005,23.3955501 267.96156,20 273.000092,20 C277.956026,20 281.34258,23.3955501 281.34258,27.7021014 C281.34258,31.9258344 277.956026,35.3213844 273.000092,35.3213844 Z M353.78181,86.3374536 L353.78181,61.2435105 C353.78181,55.197775 350.312656,51.8850433 344.943728,51.8850433 C339.5748,51.8850433 336.105647,55.197775 336.105647,61.2435105 L336.105647,86.3374536 L322.063835,86.3374536 L322.063835,61.2435105 C322.063835,55.197775 318.594681,51.8850433 313.225753,51.8850433 C307.856825,51.8850433 304.387672,55.197775 304.387672,61.2435105 L304.387672,86.3374536 L290.263261,86.3374536 L290.263261,40.1248455 L304.387672,40.1248455 L304.387672,45.9221261 C307.113435,42.1953028 311.821572,39.6279357 317.851291,39.6279357 C324.789598,39.6279357 330.406323,42.6922126 333.545081,48.2410383 C336.60124,43.354759 342.383163,39.6279357 349.073673,39.6279357 C360.47232,39.6279357 367.823622,46.9159456 367.823622,59.3386897 L367.823622,86.3374536 L353.78181,86.3374536 Z M374.927126,63.1483313 C374.927126,48.5723115 383.930406,39.4622991 395.246454,39.4622991 C402.102162,39.4622991 406.975497,42.6093943 409.453464,46.6674907 L409.453464,40.1248455 L423.577875,40.1248455 L423.577875,86.3374536 L409.453464,86.3374536 L409.453464,79.7948084 C406.892898,83.8529048 402.019563,87 395.163855,87 C383.930406,87 374.927126,77.7243511 374.927126,63.1483313 Z M409.453464,63.2311496 C409.453464,55.8603214 404.745327,51.802225 399.376399,51.802225 C394.09007,51.802225 389.299334,55.7775031 389.299334,63.1483313 C389.299334,70.5191595 394.09007,74.6600742 399.376399,74.6600742 C404.745327,74.6600742 409.453464,70.6019778 409.453464,63.2311496 Z M436.050307,70.2707046 L436.050307,51.8850433 L430.433583,51.8850433 L430.433583,40.1248455 L436.050307,40.1248455 L436.050307,28.8615575 L450.174718,28.8615575 L450.174718,40.1248455 L459.425794,40.1248455 L459.425794,51.8850433 L450.174718,51.8850433 L450.174718,70.4363412 C450.174718,73.1693449 451.331103,74.328801 454.469861,74.328801 L459.508393,74.328801 L459.508393,86.3374536 L452.322289,86.3374536 C442.740818,86.3374536 436.050307,82.2793572 436.050307,70.2707046 Z M512.454284,63.2311496 C512.454284,77.8899876 501.881625,87 488.335407,87 C474.789188,87 464.546926,77.8899876 464.546926,63.2311496 C464.546926,48.5723115 475.036985,39.4622991 488.500605,39.4622991 C502.046823,39.4622991 512.454284,48.5723115 512.454284,63.2311496 Z M478.919133,63.2311496 C478.919133,71.0160692 483.214275,74.7428925 488.335407,74.7428925 C493.373939,74.7428925 498.082076,71.0160692 498.082076,63.2311496 C498.082076,55.3634116 493.456538,51.7194067 488.500605,51.7194067 C483.379473,51.7194067 478.919133,55.3634116 478.919133,63.2311496 Z M534.095194,64.8875155 L534.095194,86.3374536 L519.970783,86.3374536 L519.970783,40.1248455 L534.095194,40.1248455 L534.095194,47.8269468 C537.316551,42.9406675 542.355083,39.6279357 548.55,39.6279357 L548.55,54.618047 L544.667852,54.618047 C537.977342,54.618047 534.095194,56.9369592 534.095194,64.8875155 Z",
        fill: "#242B3A"
      },
      "haiku:By-Haiku-Copy-c0ce72c9dbe76d77": {
        d:
          "M429.665922,101.646418 C430.575892,100.030128 432.473829,98.7052993 434.995746,98.7052993 C438.843618,98.7052993 441.755522,101.619921 441.755522,106.150834 C441.755522,110.65525 438.817619,113.702355 434.995746,113.702355 C432.395832,113.702355 430.549893,112.377527 429.665922,110.787733 L429.665922,113.463886 L427.3,113.463886 L427.3,93.8564279 L429.665922,93.8564279 L429.665922,101.646418 Z M439.337602,106.150834 C439.337602,102.732777 437.127675,100.798528 434.501762,100.798528 C431.927847,100.798528 429.665922,102.812267 429.665922,106.177331 C429.665922,109.595388 431.927847,111.58263 434.501762,111.58263 C437.127675,111.58263 439.337602,109.568891 439.337602,106.150834 Z M450.28324,110.708243 L454.703094,98.9437684 L457.147013,98.9437684 L448.567297,120.3 L446.123378,120.3 L448.931285,113.304907 L443.185475,98.9437684 L445.811388,98.9437684 L450.28324,110.708243 Z M478.050322,113.463886 L478.050322,105.090972 L468.820627,105.090972 L468.820627,113.463886 L466.454706,113.463886 L466.454706,94.9957802 L468.820627,94.9957802 L468.820627,103.103729 L478.050322,103.103729 L478.050322,94.9957802 L480.416244,94.9957802 L480.416244,113.463886 L478.050322,113.463886 Z M483.536141,106.150834 C483.536141,101.619921 486.474044,98.7052993 490.295917,98.7052993 C492.94783,98.7052993 494.76777,100.083121 495.599742,101.593425 L495.599742,98.9437684 L497.991663,98.9437684 L497.991663,113.463886 L495.599742,113.463886 L495.599742,110.761237 C494.741771,112.324534 492.895832,113.702355 490.269918,113.702355 C486.474044,113.702355 483.536141,110.65525 483.536141,106.150834 Z M495.599742,106.177331 C495.599742,102.812267 493.363816,100.798528 490.763902,100.798528 C488.163988,100.798528 485.954061,102.732777 485.954061,106.150834 C485.954061,109.568891 488.163988,111.58263 490.763902,111.58263 C493.363816,111.58263 495.599742,109.595388 495.599742,106.177331 Z M501.995531,113.463886 L501.995531,98.9437684 L504.361453,98.9437684 L504.361453,113.463886 L501.995531,113.463886 Z M503.21749,96.5855741 C502.30752,96.5855741 501.605544,95.8701668 501.605544,94.942787 C501.605544,94.0154073 502.30752,93.3 503.21749,93.3 C504.075462,93.3 504.777439,94.0154073 504.777439,94.942787 C504.777439,95.8701668 504.075462,96.5855741 503.21749,96.5855741 Z M508.391319,113.463886 L508.391319,93.8564279 L510.757241,93.8564279 L510.757241,105.382434 L516.24306,98.9437684 L519.544951,98.9437684 L512.837172,106.177331 L519.57095,113.463886 L516.347056,113.463886 L510.757241,107.051717 L510.757241,113.463886 L508.391319,113.463886 Z M534.416459,98.9437684 L534.416459,113.463886 L532.050537,113.463886 L532.050537,111.317664 C531.140567,112.827969 529.398625,113.675859 527.500688,113.675859 C524.224796,113.675859 521.650881,111.609127 521.650881,107.449166 L521.650881,98.9437684 L523.990804,98.9437684 L523.990804,107.131207 C523.990804,110.072326 525.576751,111.58263 527.968672,111.58263 C530.412591,111.58263 532.050537,110.045829 532.050537,106.919235 L532.050537,98.9437684 L534.416459,98.9437684 Z M544.048174,95.7906771 C541.500258,95.7906771 539.888311,97.5924436 539.888311,100.16261 C539.888311,102.732777 541.500258,104.534544 544.048174,104.534544 C546.57009,104.534544 548.234035,102.732777 548.234035,100.16261 C548.234035,97.5924436 546.57009,95.7906771 544.048174,95.7906771 Z M544.048174,105.594406 C540.954276,105.594406 538.770348,103.289205 538.770348,100.16261 C538.770348,97.0360157 540.954276,94.7573111 544.048174,94.7573111 C547.116072,94.7573111 549.3,97.0360157 549.3,100.16261 C549.3,103.289205 547.116072,105.594406 544.048174,105.594406 Z M546.388096,99.0497547 C546.388096,99.8976447 545.920112,100.507066 545.166137,100.745535 L546.622089,102.94475 L544.984143,102.971246 L543.736184,100.851521 L543.294199,100.851521 L543.294199,102.971246 L541.942243,102.971246 L541.942243,97.2744848 L544.438161,97.2744848 C545.608122,97.2744848 546.388096,97.9633955 546.388096,99.0497547 Z M544.360163,98.5198234 L543.294199,98.5198234 L543.294199,99.7121688 L544.360163,99.7121688 C544.724151,99.7121688 545.036141,99.5266928 545.036141,99.1027478 C545.036141,98.6788027 544.724151,98.5198234 544.360163,98.5198234 Z",
        fill: "#242B3A"
      },
      "haiku:Symbol-Copy-919a79d121aeac69": {
        d:
          "M85.540685,98.9079382 C89.264209,87.3407875 94.7331511,78.5199377 101.352333,69.4406778 C102.259694,68.1960875 104.143431,67.1322612 106.049509,67.3042494 C106.052068,67.3042064 106.054725,67.3040666 106.05748,67.3038303 C106.059169,67.3039986 106.060844,67.3041383 106.062505,67.3042494 C107.650638,67.410477 109.022187,68.2369478 110.177149,69.783662 L125.735271,96.9026752 C127.020649,99.1431897 127.462227,101.636798 127.159606,104.015819 C126.610838,109.621348 121.927878,114 116.232096,114 C116.165885,114 116.099812,113.999408 116.03388,113.99823 C115.966908,113.999409 115.899888,114 115.832829,114 L95.8294494,114 C95.8144014,113.999969 95.7993184,114 95.7842282,114 C89.7194446,114 84.802966,109.035629 84.802966,102.911767 C84.802966,102.121529 84.8848349,101.350599 85.0404756,100.607153 C85.049664,100.514803 85.0683533,100.421091 85.0972554,100.325907 C85.1067564,100.294617 85.1162698,100.263347 85.1257957,100.232098 C85.2371392,99.7790728 85.3760699,99.337047 85.5406833,98.9079436 Z M99.7223565,52.6464095 C99.7223429,52.6580676 99.722336,52.6697263 99.722336,52.6813857 C99.722336,53.5441276 99.6500376,54.2226777 99.323648,54.9732996 C84.3558139,89.3959115 50.4807595,113.536206 10.9699936,113.993393 C4.84648885,113.786717 -0.0542175247,108.757512 -0.0542175247,102.583686 C-0.0542175247,100.590429 0.467659619,98.6319083 1.45950137,96.9029429 L53.6932313,5.84979439 C56.8306188,0.380741873 63.807517,-1.50944607 69.2765695,1.62794145 C71.0333586,2.6357446 72.4904182,4.09276475 73.4982688,5.84952665 L99.0735933,50.4293021 C99.4460297,51.0578887 99.6622772,51.7969067 99.722336,52.6463561 L99.7223565,52.6464095 Z M100.707192,40.9706033 C100.687929,39.3839694 101.514458,37.4399786 103.257084,35.3398411 L111.825331,25.7784716 C114.057304,23.0885953 117.654809,23.09836 119.87868,25.7784716 L128.446926,35.3398411 C130.190356,37.4409456 131.017879,39.3845567 130.999707,40.9706033 C131.017879,42.5566499 130.190356,44.500261 128.446926,46.6013655 L119.87868,56.162735 C117.654809,58.8428466 114.057304,58.8526112 111.825331,56.162735 L103.257084,46.6013655 C101.514458,44.501228 100.687929,42.5572372 100.707192,40.9706033 Z",
        fill: "url(#linearGradient-1-176eee)"
      },
      "haiku:Page-1-8231b9d094ee1082": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Full-Group-8927369bb14bff2f": {
        fill: "#242B3A",
        fillRule: "nonzero",
        "translation.x": -427,
        "translation.y": -93
      },
      "haiku:By-Haiku-Copy-57a5aa462a0d761b": {
        d:
          "M429.665922,101.646418 C430.575892,100.030128 432.473829,98.7052993 434.995746,98.7052993 C438.843618,98.7052993 441.755522,101.619921 441.755522,106.150834 C441.755522,110.65525 438.817619,113.702355 434.995746,113.702355 C432.395832,113.702355 430.549893,112.377527 429.665922,110.787733 L429.665922,113.463886 L427.3,113.463886 L427.3,93.8564279 L429.665922,93.8564279 L429.665922,101.646418 Z M439.337602,106.150834 C439.337602,102.732777 437.127675,100.798528 434.501762,100.798528 C431.927847,100.798528 429.665922,102.812267 429.665922,106.177331 C429.665922,109.595388 431.927847,111.58263 434.501762,111.58263 C437.127675,111.58263 439.337602,109.568891 439.337602,106.150834 Z M450.28324,110.708243 L454.703094,98.9437684 L457.147013,98.9437684 L448.567297,120.3 L446.123378,120.3 L448.931285,113.304907 L443.185475,98.9437684 L445.811388,98.9437684 L450.28324,110.708243 Z M478.050322,113.463886 L478.050322,105.090972 L468.820627,105.090972 L468.820627,113.463886 L466.454706,113.463886 L466.454706,94.9957802 L468.820627,94.9957802 L468.820627,103.103729 L478.050322,103.103729 L478.050322,94.9957802 L480.416244,94.9957802 L480.416244,113.463886 L478.050322,113.463886 Z M483.536141,106.150834 C483.536141,101.619921 486.474044,98.7052993 490.295917,98.7052993 C492.94783,98.7052993 494.76777,100.083121 495.599742,101.593425 L495.599742,98.9437684 L497.991663,98.9437684 L497.991663,113.463886 L495.599742,113.463886 L495.599742,110.761237 C494.741771,112.324534 492.895832,113.702355 490.269918,113.702355 C486.474044,113.702355 483.536141,110.65525 483.536141,106.150834 Z M495.599742,106.177331 C495.599742,102.812267 493.363816,100.798528 490.763902,100.798528 C488.163988,100.798528 485.954061,102.732777 485.954061,106.150834 C485.954061,109.568891 488.163988,111.58263 490.763902,111.58263 C493.363816,111.58263 495.599742,109.595388 495.599742,106.177331 Z M501.995531,113.463886 L501.995531,98.9437684 L504.361453,98.9437684 L504.361453,113.463886 L501.995531,113.463886 Z M503.21749,96.5855741 C502.30752,96.5855741 501.605544,95.8701668 501.605544,94.942787 C501.605544,94.0154073 502.30752,93.3 503.21749,93.3 C504.075462,93.3 504.777439,94.0154073 504.777439,94.942787 C504.777439,95.8701668 504.075462,96.5855741 503.21749,96.5855741 Z M508.391319,113.463886 L508.391319,93.8564279 L510.757241,93.8564279 L510.757241,105.382434 L516.24306,98.9437684 L519.544951,98.9437684 L512.837172,106.177331 L519.57095,113.463886 L516.347056,113.463886 L510.757241,107.051717 L510.757241,113.463886 L508.391319,113.463886 Z M534.416459,98.9437684 L534.416459,113.463886 L532.050537,113.463886 L532.050537,111.317664 C531.140567,112.827969 529.398625,113.675859 527.500688,113.675859 C524.224796,113.675859 521.650881,111.609127 521.650881,107.449166 L521.650881,98.9437684 L523.990804,98.9437684 L523.990804,107.131207 C523.990804,110.072326 525.576751,111.58263 527.968672,111.58263 C530.412591,111.58263 532.050537,110.045829 532.050537,106.919235 L532.050537,98.9437684 L534.416459,98.9437684 Z M544.048174,95.7906771 C541.500258,95.7906771 539.888311,97.5924436 539.888311,100.16261 C539.888311,102.732777 541.500258,104.534544 544.048174,104.534544 C546.57009,104.534544 548.234035,102.732777 548.234035,100.16261 C548.234035,97.5924436 546.57009,95.7906771 544.048174,95.7906771 Z M544.048174,105.594406 C540.954276,105.594406 538.770348,103.289205 538.770348,100.16261 C538.770348,97.0360157 540.954276,94.7573111 544.048174,94.7573111 C547.116072,94.7573111 549.3,97.0360157 549.3,100.16261 C549.3,103.289205 547.116072,105.594406 544.048174,105.594406 Z M546.388096,99.0497547 C546.388096,99.8976447 545.920112,100.507066 545.166137,100.745535 L546.622089,102.94475 L544.984143,102.971246 L543.736184,100.851521 L543.294199,100.851521 L543.294199,102.971246 L541.942243,102.971246 L541.942243,97.2744848 L544.438161,97.2744848 C545.608122,97.2744848 546.388096,97.9633955 546.388096,99.0497547 Z M544.360163,98.5198234 L543.294199,98.5198234 L543.294199,99.7121688 L544.360163,99.7121688 C544.724151,99.7121688 545.036141,99.5266928 545.036141,99.1027478 C545.036141,98.6788027 544.724151,98.5198234 544.360163,98.5198234 Z",
        fill: {
          "0": {
            value: Haiku.inject(function(fgColor) {
              return fgColor;
            }, "fgColor"),
            edited: true
          }
        }
      },
      "haiku:A-60a7b6cff49ddbcd": {
        "style.position": "absolute",
        "sizeMode.y": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 59,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeAbsolute.y": 59,
        "translation.x": 175.5,
        "translation.y": 57.634,
        "style.zIndex": { "0": { value: 5, edited: true } },
        opacity: {
          "0": { value: 0, edited: true },
          "733": { value: 0, edited: true, curve: "easeInOutQuad" },
          "833": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "733": { value: 0.2, edited: true, curve: "easeOutBack" },
          "833": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "733": { value: 0.2, edited: true, curve: "linear" },
          "833": { value: 1, edited: true }
        }
      },
      "haiku:Page-1-db53375093b5cfb6": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:A-7b799984cea8de28": {
        d:
          "M43.9144189,58.3374536 L40.4452654,48.0679852 L18.8043554,48.0679852 L15.3352019,58.3374536 L0.55,58.3374536 L21.5301189,0.199011125 L37.8846997,0.199011125 L58.8648186,58.3374536 L43.9144189,58.3374536 Z M36.8109141,37.1359703 L29.6248104,15.8516687 L22.5213056,37.1359703 L36.8109141,37.1359703 Z",
        fill: {
          "0": {
            value: Haiku.inject(function(fgColor) {
              return fgColor;
            }, "fgColor"),
            edited: true
          }
        },
        fillRule: "nonzero"
      },
      "haiku:N-016521ebe7058254": {
        "style.position": "absolute",
        "sizeMode.y": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 47,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeAbsolute.y": 48,
        "translation.x": 234.073,
        "translation.y": 63.428,
        "style.zIndex": { "0": { value: 6, edited: true } },
        opacity: {
          "0": { value: 0, edited: true },
          "700": { value: 0, edited: true, curve: "easeInOutQuad" },
          "800": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "700": { value: 0.2, edited: true, curve: "easeOutBack" },
          "800": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "700": { value: 0.2, edited: true, curve: "linear" },
          "800": { value: 1, edited: true }
        }
      },
      "haiku:Page-1-0af6ab7808ab18ba": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:N-df271b68bc42b356": {
        d:
          "M32.0255073,47.3374536 L32.0255073,22.2435105 C32.0255073,15.9493201 28.5563538,12.4709518 23.1874257,12.4709518 C17.8184976,12.4709518 14.3493441,15.9493201 14.3493441,22.2435105 L14.3493441,47.3374536 L0.224933388,47.3374536 L0.224933388,1.12484549 L14.3493441,1.12484549 L14.3493441,7.25339926 C17.1577065,3.36093943 22.1136401,0.627935723 28.3085571,0.627935723 C38.9638143,0.627935723 46.0673191,7.91594561 46.0673191,20.3386897 L46.0673191,47.3374536 L32.0255073,47.3374536 Z",
        fill: {
          "0": {
            value: Haiku.inject(function(fgColor) {
              return fgColor;
            }, "fgColor"),
            edited: true
          }
        },
        fillRule: "nonzero"
      },
      "haiku:I-cc1df529da5abb84": {
        "style.position": "absolute",
        "sizeMode.y": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 18,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeAbsolute.y": 67,
        "translation.x": 273.736,
        "translation.y": 53.572,
        "style.zIndex": { "0": { value: 7, edited: true } },
        opacity: {
          "0": { value: 0, edited: true },
          "667": { value: 0, edited: true, curve: "easeInOutQuad" },
          "783": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "667": { value: 0.2, edited: true, curve: "easeOutBack" },
          "783": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "667": { value: 0.2, edited: true, curve: "linear" },
          "783": { value: 1, edited: true }
        }
      },
      "haiku:Page-1-20a5c9ba7850082f": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:I-a9d6c79e21286a54": {
        d:
          "M1.89658742,66.3374536 L1.89658742,20.1248455 L16.0209982,20.1248455 L16.0209982,66.3374536 L1.89658742,66.3374536 Z M9.00009223,15.3213844 C3.96155975,15.3213844 0.575005124,11.9258344 0.575005124,7.70210136 C0.575005124,3.39555006 3.96155975,-5.32907052e-15 9.00009223,-5.32907052e-15 C13.9560258,-5.32907052e-15 17.3425804,3.39555006 17.3425804,7.70210136 C17.3425804,11.9258344 13.9560258,15.3213844 9.00009223,15.3213844 Z",
        fill: {
          "0": {
            value: Haiku.inject(function(fgColor) {
              return fgColor;
            }, "fgColor"),
            edited: true
          }
        },
        fillRule: "nonzero"
      },
      "haiku:M-d3ac45be249f7398": {
        "style.position": "absolute",
        "sizeMode.y": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 78,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeAbsolute.y": 48,
        "translation.x": 329.734,
        "translation.y": 62.476,
        "style.zIndex": { "0": { value: 8, edited: true } },
        opacity: {
          "0": { value: 0, edited: true },
          "650": { value: 0, edited: true, curve: "easeInOutQuad" },
          "767": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "650": { value: 0.2, edited: true, curve: "easeOutBack" },
          "767": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "650": { value: 0.2, edited: true, curve: "linear" },
          "767": { value: 1, edited: true }
        }
      },
      "haiku:Page-1-98d5a353471c86f6": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:M-9717c88649b34a47": {
        d:
          "M63.7818098,47.3374536 L63.7818098,22.2435105 C63.7818098,16.197775 60.3126563,12.8850433 54.9437282,12.8850433 C49.5748002,12.8850433 46.1056466,16.197775 46.1056466,22.2435105 L46.1056466,47.3374536 L32.0638348,47.3374536 L32.0638348,22.2435105 C32.0638348,16.197775 28.5946813,12.8850433 23.2257532,12.8850433 C17.8568252,12.8850433 14.3876717,16.197775 14.3876717,22.2435105 L14.3876717,47.3374536 L0.263260914,47.3374536 L0.263260914,1.12484549 L14.3876717,1.12484549 L14.3876717,6.92212608 C17.1134351,3.19530284 21.821572,0.627935723 27.8512912,0.627935723 C34.7895983,0.627935723 40.406323,3.69221261 43.545081,9.24103832 C46.60124,4.35475896 52.3831625,0.627935723 59.0736729,0.627935723 C70.4723201,0.627935723 77.8236216,7.91594561 77.8236216,20.3386897 L77.8236216,47.3374536 L63.7818098,47.3374536 Z",
        fill: {
          "0": {
            value: Haiku.inject(function(fgColor) {
              return fgColor;
            }, "fgColor"),
            edited: true
          }
        },
        fillRule: "nonzero"
      },
      "haiku:A-Minus-02c01a1208ad7ada": {
        "style.position": "absolute",
        "sizeMode.y": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 50,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeAbsolute.y": 48,
        "translation.x": 401,
        "translation.y": 62.522003173828125,
        "style.zIndex": { "0": { value: 9, edited: true } },
        opacity: {
          "0": { value: 0, edited: true },
          "633": { value: 0, edited: true, curve: "easeInOutQuad" },
          "733": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "633": { value: 0.2, edited: true, curve: "easeOutBack" },
          "733": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "633": { value: 0.2, edited: true, curve: "linear" },
          "733": { value: 1, edited: true }
        }
      },
      "haiku:Page-1-23d1396f42ac176b": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:A-Minus-53a8d74d102c7605": {
        d:
          "M0.92712646,24.1483313 C0.92712646,9.5723115 9.93040582,0.462299135 21.2464542,0.462299135 C28.1021623,0.462299135 32.975497,3.60939431 35.4534638,7.66749073 L35.4534638,1.12484549 L49.5778746,1.12484549 L49.5778746,47.3374536 L35.4534638,47.3374536 L35.4534638,40.7948084 C32.8928981,44.8529048 28.0195634,48 21.1638553,48 C9.93040582,48 0.92712646,38.7243511 0.92712646,24.1483313 Z M35.4534638,24.2311496 C35.4534638,16.8603214 30.7453269,12.802225 25.3763989,12.802225 C20.0900697,12.802225 15.2993339,16.7775031 15.2993339,24.1483313 C15.2993339,31.5191595 20.0900697,35.6600742 25.3763989,35.6600742 C30.7453269,35.6600742 35.4534638,31.6019778 35.4534638,24.2311496 Z",
        fill: {
          "0": {
            value: Haiku.inject(function(fgColor) {
              return fgColor;
            }, "fgColor"),
            edited: true
          }
        },
        fillRule: "nonzero"
      },
      "haiku:T-ea14c5fbc8e7d36a": {
        "style.position": "absolute",
        "sizeMode.y": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 30,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeAbsolute.y": 59,
        "translation.x": 445.917,
        "translation.y": 57.381,
        "style.zIndex": { "0": { value: 10, edited: true } },
        opacity: {
          "0": { value: 0, edited: true },
          "550": { value: 0, edited: true, curve: "easeInOutQuad" },
          "650": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "550": { value: 0.2, edited: true, curve: "easeOutBack" },
          "650": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "550": { value: 0.2, edited: true, curve: "linear" },
          "650": { value: 1, edited: true }
        }
      },
      "haiku:Page-1-ffe2dea8e392c87d": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:T-845f4049f64732ee": {
        d:
          "M6.05030744,42.2707046 L6.05030744,23.8850433 L0.433582701,23.8850433 L0.433582701,12.1248455 L6.05030744,12.1248455 L6.05030744,0.861557478 L20.1747182,0.861557478 L20.1747182,12.1248455 L29.4257942,12.1248455 L29.4257942,23.8850433 L20.1747182,23.8850433 L20.1747182,42.4363412 C20.1747182,45.1693449 21.3311027,46.328801 24.4698606,46.328801 L29.5083931,46.328801 L29.5083931,58.3374536 L22.3222894,58.3374536 C12.7408178,58.3374536 6.05030744,54.2793572 6.05030744,42.2707046 Z",
        fill: {
          "0": {
            value: Haiku.inject(function(fgColor) {
              return fgColor;
            }, "fgColor"),
            edited: true
          }
        },
        fillRule: "nonzero"
      },
      "haiku:O-5001e192f84a5f10": {
        "style.position": "absolute",
        "sizeMode.y": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 49,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeAbsolute.y": 48,
        "translation.x": 488.772,
        "translation.y": 62.333,
        "style.zIndex": { "0": { value: 11, edited: true } },
        opacity: {
          "0": { value: 0, edited: true },
          "483": { value: 0, edited: true, curve: "easeInOutQuad" },
          "583": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "483": { value: 0.2, edited: true, curve: "easeOutBack" },
          "583": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "483": { value: 0.2, edited: true, curve: "linear" },
          "583": { value: 1, edited: true }
        }
      },
      "haiku:Page-1-645384bc23013106": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:O-6f0a6cdca12f0d72": {
        d:
          "M48.4542837,24.2311496 C48.4542837,38.8899876 37.8816253,48 24.3354068,48 C10.7891884,48 0.5469256,38.8899876 0.5469256,24.2311496 C0.5469256,9.5723115 11.036985,0.462299135 24.5006046,0.462299135 C38.0468231,0.462299135 48.4542837,9.5723115 48.4542837,24.2311496 Z M14.919133,24.2311496 C14.919133,32.0160692 19.2142755,35.7428925 24.3354068,35.7428925 C29.3739393,35.7428925 34.0820762,32.0160692 34.0820762,24.2311496 C34.0820762,16.3634116 29.4565382,12.7194067 24.5006046,12.7194067 C19.3794733,12.7194067 14.919133,16.3634116 14.919133,24.2311496 Z",
        fill: {
          "0": {
            value: Haiku.inject(function(fgColor) {
              return fgColor;
            }, "fgColor"),
            edited: true
          }
        },
        fillRule: "nonzero"
      },
      "haiku:R-786a3cdbf18d78b4": {
        "style.position": "absolute",
        "sizeMode.y": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 30,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeAbsolute.y": 48,
        "translation.x": 534.198,
        "translation.y": 62.285,
        "style.zIndex": { "0": { value: 12, edited: true } },
        opacity: {
          "0": { value: 0, edited: true },
          "433": { value: 0, edited: true, curve: "easeInOutQuad" },
          "533": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true, curve: "easeInOutQuad" },
          "433": { value: 0.5, curve: "easeOutBack", edited: true },
          "533": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true, curve: "easeInOutQuad" },
          "433": { value: 0.5, curve: "linear", edited: true },
          "533": { value: 1, edited: true }
        }
      },
      "haiku:Page-1-3fdbc356cdcb9e39": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:R-06efdfe2ab4f76a3": {
        d:
          "M15.0951937,25.8875155 L15.0951937,47.3374536 L0.970782947,47.3374536 L0.970782947,1.12484549 L15.0951937,1.12484549 L15.0951937,8.82694685 C18.3165505,3.94066749 23.355083,0.627935723 29.55,0.627935723 L29.55,15.618047 L25.667852,15.618047 C18.9773417,15.618047 15.0951937,17.9369592 15.0951937,25.8875155 Z",
        fill: {
          "0": {
            value: Haiku.inject(function(fgColor) {
              return fgColor;
            }, "fgColor"),
            edited: true
          }
        },
        fillRule: "nonzero"
      }
    }
  },
  template: {
    elementName: "div",
    attributes: { "haiku-id": "Main-03757d2ca1026e0a", "haiku-title": "Main" },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "R-786a3cdbf18d78b4",
          "haiku-title": "R",
          "haiku-source": "designs/animator.sketch.contents/slices/R.svg#lock"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-3fdbc356cdcb9e39", id: "Page-1" },
            children: [
              {
                elementName: "path",
                attributes: { "haiku-id": "R-06efdfe2ab4f76a3", id: "R" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "O-5001e192f84a5f10",
          "haiku-title": "O",
          "haiku-source": "designs/animator.sketch.contents/slices/O.svg#lock"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-645384bc23013106", id: "Page-1" },
            children: [
              {
                elementName: "path",
                attributes: { "haiku-id": "O-6f0a6cdca12f0d72", id: "O" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "T-ea14c5fbc8e7d36a",
          "haiku-title": "T",
          "haiku-source": "designs/animator.sketch.contents/slices/T.svg#lock"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-ffe2dea8e392c87d", id: "Page-1" },
            children: [
              {
                elementName: "path",
                attributes: { "haiku-id": "T-845f4049f64732ee", id: "T" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "A-Minus-02c01a1208ad7ada",
          "haiku-title": "a-minus",
          "haiku-source":
            "designs/animator.sketch.contents/slices/a-minus.svg#lock"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-23d1396f42ac176b", id: "Page-1" },
            children: [
              {
                elementName: "path",
                attributes: {
                  "haiku-id": "A-Minus-53a8d74d102c7605",
                  id: "a-minus"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "M-d3ac45be249f7398",
          "haiku-title": "M",
          "haiku-source": "designs/animator.sketch.contents/slices/M.svg#lock"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-98d5a353471c86f6", id: "Page-1" },
            children: [
              {
                elementName: "path",
                attributes: { "haiku-id": "M-9717c88649b34a47", id: "M" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "I-cc1df529da5abb84",
          "haiku-title": "I",
          "haiku-source": "designs/animator.sketch.contents/slices/I.svg#lock"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-20a5c9ba7850082f", id: "Page-1" },
            children: [
              {
                elementName: "path",
                attributes: { "haiku-id": "I-a9d6c79e21286a54", id: "I" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "N-016521ebe7058254",
          "haiku-title": "N",
          "haiku-source": "designs/animator.sketch.contents/slices/N.svg#lock"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-0af6ab7808ab18ba", id: "Page-1" },
            children: [
              {
                elementName: "path",
                attributes: { "haiku-id": "N-df271b68bc42b356", id: "N" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "A-60a7b6cff49ddbcd",
          "haiku-title": "A",
          "haiku-source": "designs/animator.sketch.contents/slices/A.svg#lock"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-db53375093b5cfb6", id: "Page-1" },
            children: [
              {
                elementName: "path",
                attributes: { "haiku-id": "A-7b799984cea8de28", id: "A" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "By-Haiku-Copy-35944b0a063252e8",
          "haiku-title": "byHaiku® Copy",
          "haiku-source":
            "designs/animator.sketch.contents/slices/byHaiku® Copy.svg#lock"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-8231b9d094ee1082", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Full-Group-8927369bb14bff2f",
                  id: "FullGroup"
                },
                children: [
                  {
                    elementName: "path",
                    attributes: {
                      "haiku-id": "By-Haiku-Copy-57a5aa462a0d761b",
                      id: "byHaiku®-Copy"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Full-Group-086e4bed4e4c459c",
          "haiku-title": "FullGroup",
          "haiku-source":
            "designs/animator.sketch.contents/slices/FullGroup.svg",
          "haiku-locked": true
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "Defs-57cbc94dd7438378" },
            children: [
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "Linear-Gradient-1-176eee-23a6b10f96a0babb",
                  id: "linearGradient-1-176eee"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-934c92bd402c280e" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-bed321f8d0b812fd" },
                    children: []
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-82f29448178d578a", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Full-Group-37c9aede0f61e809",
                  id: "FullGroup"
                },
                children: [
                  {
                    elementName: "path",
                    attributes: {
                      "haiku-id": "Animator-Copy-70d065c90ce41146",
                      id: "Animator-Copy"
                    },
                    children: []
                  },
                  {
                    elementName: "path",
                    attributes: {
                      "haiku-id": "By-Haiku-Copy-c0ce72c9dbe76d77",
                      id: "byHaiku®-Copy"
                    },
                    children: []
                  },
                  {
                    elementName: "path",
                    attributes: {
                      "haiku-id": "Symbol-Copy-919a79d121aeac69",
                      id: "symbol-copy"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Diamond-Copy-32-012380ac5456526a",
          "haiku-title": "HeroDiam",
          "haiku-source":
            "designs/animator.sketch.contents/slices/Diamond Copy 32.svg#lock"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "Defs-e264f8021e5a187d" },
            children: [
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "Linear-Gradient-1-13dfc6-38d7a30a8ef0258a",
                  id: "linearGradient-1-13dfc6"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-988850c829312872" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-bb8bcc406964d868" },
                    children: []
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-a697b632a22d76c8", id: "Page-1" },
            children: [
              {
                elementName: "path",
                attributes: {
                  "haiku-id": "Diamond-Copy-32-89844bd46ba48c4f",
                  id: "Diamond-Copy-32"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Path-2-af1a6cd5d22c7ebf",
          "haiku-title": "Little Tri",
          "haiku-source":
            "designs/animator.sketch.contents/slices/Path 2.svg#lock"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "Defs-f06a28a08f2d458d" },
            children: [
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "Linear-Gradient-1-A2f1bf-dd579bf2bb55ca45",
                  id: "linearGradient-1-a2f1bf"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-490ca8708059018e" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-bd5d9c00639d63bb" },
                    children: []
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-d0721883a5cc8b0d", id: "Page-1" },
            children: [
              {
                elementName: "path",
                attributes: {
                  "haiku-id": "Path-2-7a635180adee9604",
                  id: "Path-2"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Path-2-dfa4f1f6cca73d4f",
          "haiku-title": "Big Tri",
          "haiku-source":
            "designs/animator.sketch.contents/slices/Path 2.svg#lock"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "Defs-10ae01dfbebcc0af" },
            children: [
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "Linear-Gradient-1-2db749-95a3f9579dad9a19",
                  id: "linearGradient-1-2db749"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-cdeb99092b9623d8" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-c0421130149019d6" },
                    children: []
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-9fa83a73d34094a2", id: "Page-1" },
            children: [
              {
                elementName: "path",
                attributes: {
                  "haiku-id": "Path-2-c91fc96c9ea04b29",
                  id: "Path-2"
                },
                children: []
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/zack4-animatorlogo/code/main/code.js
// module id = 470
// module chunks = 35783957827783